module.exports = __webpack_public_path__ + "static/media/chat-icon.926f3f21.svg";